import { render, staticRenderFns } from "./selectcustomer.vue?vue&type=template&id=0f3c5e40&scoped=true&"
import script from "./selectcustomer.vue?vue&type=script&lang=js&"
export * from "./selectcustomer.vue?vue&type=script&lang=js&"
import style0 from "./selectcustomer.vue?vue&type=style&index=0&id=0f3c5e40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3c5e40",
  null
  
)

export default component.exports